export default function errorHandler(props) {
    window.onerror = function (errorMsg, url, lineNumber, column, errorObj) {
        //Validación para browsers que no poseen los parametros column y errorObj en la definición del evento window.onerror
        if (column != undefined | errorObj != undefined) {
            switch (errorObj.name) {
                case NotifyFailedValidations.name: //400
                    alert((new NotifyFailedValidations()).message);
                    console.error(errorMsg, errorObj);
                    jsLogger.fatal(new NotifyFailedValidations().message);
                    break;
                case NotAuthorized.name: //401
                    $('#modal-no-autorizado').modal('show');//alert('Se produjo un error en la operación por falta de permisos. Contáctese con el personal de soporte.');
                    console.error(errorMsg, errorObj);
                    jsLogger.fatal(new NotAuthorized().message);
                    break;
                case AccessDenied.name: //403
                    console.error(errorMsg, errorObj);
                    jsLogger.fatal(new NotAuthorized().message);

                    //Si llega forbidden deslogueo al usuario.
                    props.cerrarSesion();
                    break;
                case NotFoundError.name: //404
                    alert((new NotFoundError()).message);
                    console.error(errorMsg, errorObj);
                    jsLogger.fatal(new NotFoundError().message);
                    break;
                case VerbNotAllowedOrMethodNotFoundError.name: //405
                    console.error(errorMsg, errorObj);
                    alert((new VerbNotAllowedOrMethodNotFoundError()).message);
                    jsLogger.fatal(new VerbNotAllowedOrMethodNotFoundError().message);
                    break;
                case NotAcceptable.name: //406
                    alert((new NotAcceptable()).message);
                    console.error(errorMsg, errorObj);
                    jsLogger.fatal(new NotAcceptable().message);
                    break;
                case ServerSideUnhandledExceptionError.name: //500
                    console.error(errorMsg, errorObj);
                    alert((new ServerSideUnhandledExceptionError()).message);
                    jsLogger.fatal(new ServerSideUnhandledExceptionError().message);
                    break;
                case ValidationFailedError.name:
                    console.error(errorMsg, errorObj);
                    alert((new ValidationFailedError()).message);
                    jsLogger.fatal(new ValidationFailedError().message);
                    break;
                case BlockedOrRestrictedEndpointError.name: //0
                    console.error(errorMsg, errorObj);
                    //AD17-2657 - SE COMENTA PARA QUE NO DE UN ALERT CUANDO DA TIMEOUT LA LLAMADA A LA RULE "EJECUCIONPROCESOSCONTABILIZADORRECONTABILIZADOR" POR TARDAR DEMASIADO
                    //ToDo: Se debe verificar el comportamiento de los paquetes npm de GyF de "com-gyf-webcore-servicehub" para controlar mejor este comportamiento
                    //alert((new BlockedOrRestrictedEndpointError()).message);
                    jsLogger.fatal(new BlockedOrRestrictedEndpointError().message);
                    break;
                default:
                    console.error(errorMsg, errorObj);
                    //AD17-2657 - SE COMENTA PARA QUE NO DE UN ALERT CUANDO DA TIMEOUT LA LLAMADA A LA RULE "EJECUCIONPROCESOSCONTABILIZADORRECONTABILIZADOR" POR TARDAR DEMASIADO
                    //ToDo: Se debe verificar el comportamiento de los paquetes npm de GyF de "com-gyf-webcore-servicehub" para controlar mejor este comportamiento
                    //alert("Se produjo un error en la operación. Consulte los detalles en la consola del navegador y contáctese con el personal de soporte.");
                    // Log en el servidor.
                    jsLogger.fatalException({
                        "errorMsg": errorMsg,
                        "url": url,
                        "line number": lineNumber,
                        "column": column,
                        "version": "NOT INFORMED", // Deberá resolverse en el contexto de la tarea #5302
                        "executionMode": "NOT INFORMED", // Deberá resolverse en el contexto de la tarea #5302
                        "userAgent": navigator.userAgent
                    }, errorObj);
            }
            return true;
        } else {
            console.error(errorMsg, errorObj);
            alert("Se produjo un error en la operación. Consulte los detalles en la consola del navegador y contáctese con el personal de soporte.");
            // Log en el servidor.
            jsLogger.fatalException({
                "errorMsg": errorMsg,
                "url": url,
                "line number": lineNumber,
                "version": "NOT INFORMED", // Deberá resolverse en el contexto de la tarea #5302
                "executionMode": "NOT INFORMED", // Deberá resolverse en el contexto de la tarea #5302
                "userAgent": navigator.userAgent
            });
        }
    };

    function NotifyFailedValidations(modelState, raiseError) {
        var errors = [];
        for (var key in modelState) {
            for (var i = 0; i < modelState[key].length; i++) {
                errors.push(modelState[key][i]);
            }
        }
        var userMessage = (new ValidationFailedError()).message;
        userMessage += ":\n";
        userMessage += errors.toString();
        if (raiseError) {
            throw new ValidationFailedError(userMessage);
        } else {
            alert(userMessage);
        }
    }

    function IsValidObject(instance) {
        return instance !== undefined && instance !== null && Object.getPrototypeOf(instance) === Object.prototype;
    }

    /*
        EXCEPCIONES CUSTOM
        Nota: antes de crear un nuevo tipo de excepción, verificar que no se pueda resolver con las que ya incluye Javascript:
            - Error:            Thrown when runtime errors occur. The Error object can also be used as a base object for user-defined exceptions.
            - RangeError:       Indicates an error when a value is not in the set or range of allowed values.
            - ReferenceError:   Represents an error when a non-existent variable is referenced.
            - SyntaxError:      Represents an error when trying to interpret syntactically invalid code.
            - TypeError:        Represents an error when a value is not of the expected type.
            - URIError:         Represents an error when a global URI handling function was used in a wrong way.
            - EvalError:        Indicates an error regarding the global eval() function.
        Fuente: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects
    */

    function BlockedOrRestrictedEndpointError(message) {
        this.name = "BlockedOrRestrictedEndpointError";
        this.message = message || "No es posible conectar con el servidor remoto. Verifique la disponibilidad del endpoint Web API (si aplica) o la vigencia de una restricción CORS.";
    }
    BlockedOrRestrictedEndpointError.prototype = new Error();
    BlockedOrRestrictedEndpointError.prototype.constructor = BlockedOrRestrictedEndpointError;

    function ServerSideUnhandledExceptionError(message) {
        this.name = "ServerSideUnhandledExceptionError";
        this.message = message || "Se produjo una excepción no controlada en el servidor de aplicación.";
    }
    ServerSideUnhandledExceptionError.prototype = new Error();
    ServerSideUnhandledExceptionError.prototype.constructor = ServerSideUnhandledExceptionError;

    function NotFoundError(message) {
        this.name = "NotFoundError";
        this.message = message || "Elemento no encontrado para realizar la operación solicitada.";
    }
    NotFoundError.prototype = new Error();
    NotFoundError.prototype.constructor = NotFoundError;

    function VerbNotAllowedOrMethodNotFoundError(message) {
        this.name = "VerbNotAllowedOrMethodNotFoundError";
        this.message = message || "Verbo no permitido o el método correspondiente del controlador no posee los parámetros adecuadamente asociados.";
    }
    VerbNotAllowedOrMethodNotFoundError.prototype = new Error();
    VerbNotAllowedOrMethodNotFoundError.prototype.constructor = VerbNotAllowedOrMethodNotFoundError;

    function ApplicationStoreMisconfiguredError(message) {
        this.name = "ApplicationStoreMisconfiguredError";
        this.message = message || "Store de aplicación fue correctamente configurado o su configuración fue descartada.";
    }
    ApplicationStoreMisconfiguredError.prototype = new Error();
    ApplicationStoreMisconfiguredError.prototype.constructor = ApplicationStoreMisconfiguredError;

    // En la mayoría de los casos es preferible no arrojar una excepción ValidationFailedError para no superpoblar el log con validaciones de usuario.
    function ValidationFailedError(message) {
        this.name = "ValidationFailedError";
        this.message = message || "Las validaciones de la operación no fueron superadas.";
    }
    ValidationFailedError.prototype = new Error();
    ValidationFailedError.prototype.constructor = ValidationFailedError;

    // Cambiar message
    function NotAuthorized(message) {
        this.name = "NotAuthorized";
        this.message = message || "401 - Unauthorized.";
    }
    NotAuthorized.prototype = new Error();
    NotAuthorized.prototype.constructor = NotAuthorized;

    // Cambiar message
    function AccessDenied(message) {
        this.name = "AccessDenied";
        this.message = message || "403 - Forbidden.";
    }
    AccessDenied.prototype = new Error();
    AccessDenied.prototype.constructor = AccessDenied;

    // Cambiar message
    function NotAcceptable(message) {
        this.name = "NotAcceptable";
        this.message = message || "406 - Not Acceptable.";
    }
    NotAcceptable.prototype = new Error();
    NotAcceptable.prototype.constructor = NotAcceptable;
}


// WEBPACK FOOTER //
// ./Portico/App/Common/Handlers/ErrorHandler.js